define('views/modules/note/note',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/i18n',
    // events
    'services/events/conversation-events',
    //models
    'collections/note/notes',
    'models/note/note',
    // views
    'views/parts/menu/menu-action',
    'views/parts/form/textbox',
    'views/parts/form/chatbox',
    'views/parts/alert/alert-list',
    'views/modules/note/list/note-list',
    'views/modules/note/note-edit-modal',
    // templates
    'text!templates/modules/note/note.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    i18n,
    // events
    ConversationEvents,
    //Collections and models
    CNotes,
    MNote,
    // views
    VMenuAction,
    VTextBox,
    VChatBox,
    VAlertList,
    VNoteList,
    VNoteEditModal,
    // templates
    TNote
) {

    var VNote = Backbone.View.extend({
        template: TNote,
        regions: {
            root: ".notes",
            menu: ".menu-actions",
            search: ".search-placeholder",
            chatbox: ".message-write",
            alert: ".alert-list",
            list: ".note-list"
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                group: opt.group,
                profile: this.model,
                model: new MNote(),
                collection: new CNotes(null, {
                    user: this.model.id,
                    group: opt.group.id
                })
            });
            
            var collection = this.collection,
                model = this.model,
                view = this.view = {
                    search: new VTextBox({
                        label: 'Search',
                        attribute: 'query',
                        model: this.queryModel
                    }),
                    chatbox: new VChatBox({
                        label: 'note:Add note',
                        // icon: 'sl-icon-check',
                        attribute: 'text',
                        model: model,
                        callback: this.onSendNote,
                        context: this
                    }),
                    list: new VNoteList({
                        collection: collection,
                        group: this.group,
                        profile: this.profile,
                        bottom: true,
                        button: {
                            label: 'note:show more notes'
                        }
                    }),
                    alert: new VAlertList({
                        collection: new Backbone.Collection([{
                            type: 'info',
                            title: 'note:Only for Coaches!',
                            message: 'note:This section is available only for coaches, customers not see your notes, they are your memory assistant attached to your clients.',
                            dismissable: true
                        }])
                    })
                };

            this.listenTo(collection, { "note:edit": this.onEditNote })
                .listenTo(model, { "model:reset": this.onModelReset });

            this.listenTo(this.actionCollection, "item:click", this.onActionClicked);
        },

        render: function() {
            var collection = this.collection;

            collection.reset(null, { silent: true });
            collection.setUser(this.profile.id, this.group.id);
            // Render Template HTML with Mustache
            var html = Mustache.render(this.template, Mustache.getContext());
            this.$el.empty().append(html);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            // this.assign(view.menu, zone.$menu)
            this.assign(view.search, zone.$search)
                .assign(view.chatbox, zone.$chatbox)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.$list);

            collection.getFirstPage();

            return this;
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e, actionModel) {
            e.preventDefault();
        },

        onSearchAction: function(e, itemModel) {
            var fade = itemModel.get('active') ? "fadeIn" : "fadeOut";
            this.zone.$search[fade](300);
        },

        onAddNoteAction: function(e, itemModel) {
            var fade = itemModel.get('active') ? "fadeIn" : "fadeOut";
            this.zone.$chatbox[fade](300);
            this.view.chatbox.resetFile();
        },

        ////////////
        // events //
        ////////////
        onSendNote: function() {
            var model = this.model;

            model.setUser(this.profile.id);
            model.setGroup(this.group.id);
            model.setAttachment(this.view.chatbox.getFile());
            model.save(model.attributes, {
                context: this,
                success: this.onSuccess,
                error: this.onError
            });

        },

        onEditNote: function(model) {
            var view = this.view.edit || (this.view.edit = new VNoteEditModal({
                group: this.group,
                profile: this.profile,
                context: this,
                callback: this.onModelChange,
            }));
            view.show(model);
        },

        onModelChange: function(model, response, options) {
            this.collection.set(model, { remove: false });
        },

        onModelReset: function(model) {
            this.view.chatbox.resetFile();
        },

        onSuccess: function(model) {
            this.collection.add(model.clone());
            this.model.reset();
            ConversationEvents.messageAjaxEnd();
        },

        onError: function (model, response, options) {
            ConversationEvents.messageAjaxEnd();
        }
    });

    return VNote;

});

